<template>
  <div class="template-360">
    <div class="chunk-warp line-one">
      <div class="img-box count-down">
        <img
          src="@assets/images/360/1.png"
          @click="handleClick(data[0])"
          alt=""
        />
        <!-- <span class="day">{{ countdown.days }}</span>
        <span class="hours">{{ countdown.hours }}</span> -->
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/2.png"
          @click="handleClick(data[1])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/3.png"
          @click="handleClick(data[2])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-two">
      <div class="img-box">
        <img
          src="@assets/images/360/4.png"
          @click="handleClick(data[3])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/5.png"
          @click="handleClick(data[4], true)"
          alt=""
        />
        <img
          src="@assets/images/360/6.png"
          @click="handleClick(data[5])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-three">
      <div class="img-box">
        <img
          src="@assets/images/360/7.png"
          @click="handleClick(data[6])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/8.png"
          @click="handleClick(data[7])"
          alt=""
        />
      </div>
    </div>
    <div class="chunk-warp line-four">
      <div class="img-box">
        <img
          src="@assets/images/360/9.png"
          @click="handleClick(data[8])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/10.png"
          @click="handleClick(data[9])"
          alt=""
        />
      </div>
      <div class="img-box">
        <img
          src="@assets/images/360/11.png"
          @click="handleClick(data[10])"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import os from '@utils/os'
export default {
  props: {
    data: {
      type: Array
    }
  },
  data () {
    return {
      countdown: {
        days: 0,
        hours: 0
      },
      interval: null
    }
  },
  mounted () {
    // console.log(this.data.map(item => item.title))
    // this.initCountdown();
    // this.interval = setInterval(this.updateCountdown, 1000 * 60); // 每分钟更新一次
  },
  computed: {
    isUid () {
      return this.$route.query.meetingId && this.$route.query.uid
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    handleClick (item) {
      if (item.jump_type == 1) {
        if (item.is_home == 1) {
          this.$router.push({
            path: '/detailIframe',
            query: {
              url: item.content_url,
              isHome: item.is_home,
              id: this.$route.query.id
            }
          })
        } else {
          let targetUrl = item.content_url
          // 判断是否需要追加 pf 和 uid 参数（CCAapp 跳转场景）
          const isDocbookUrl = /m\.docbook\.com\.cn|docbook\.com\.cn/.test(
            targetUrl
          )
          if (
            isDocbookUrl &&
            this.$route.query.uid &&
            this.$route.query.platform
          ) {
            targetUrl = os.appendQuery(targetUrl, {
              platform: this.$route.query.platform,
              uid: this.$route.query.uid
            })
          }
          if (os.isPC()) {
            if (os.isInWechatMiniProgram()) {
              //   window.location.href = targetUrl
              window.go(targetUrl)
            } else {
              window.open(targetUrl)
            }
          } else {
            // window.location.href = targetUrl
            window.go(targetUrl)
          }
        }
      } else {
        this.$router.push({
          path: '/detail',
          query: {
            id: item.id,
            isHome: item.is_home
          }
        })
      }
    },
    // 354 倒计时
    initCountdown () {
      console.log(this.subjectTime, this.serveTime)
      const serverTimeMs = Number(this.serveTime) * 1000
      const targetTime = new Date(this.subjectTime).getTime()

      if (isNaN(serverTimeMs) || isNaN(targetTime)) {
        this.invalidTime = true
        this.loading = false
        return
      }

      this.baseTime = serverTimeMs
      this.targetTime = targetTime

      this.updateCountdown()
      this.loading = false
    },
    updateCountdown () {
      const now = Date.now()
      const diff = this.targetTime - now

      if (diff <= 0) {
        this.countdown.days = 0
        this.countdown.hours = 0
        clearInterval(this.interval)
        return
      }

      const totalHours = Math.floor(diff / (1000 * 60 * 60))
      this.countdown.days = Math.floor(totalHours / 24)
      this.countdown.hours = totalHours % 24
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "AlibabaPuHuiTi-3-85-Bold";
  src: url("../../../../assets/font/AlibabaPuHuiTi-3-85-Bold.ttf")
    format("opentype");
  opacity: 1;
}
.template-360 {
  box-sizing: border-box;
  position: relative;
  margin-top: -0.2rem;
  padding-bottom: 16px;
  background: #d5e8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  z-index: 100;
  .chunk-warp {
    flex: 0 0 auto;
    // padding-left: 8px;
    // padding-right: 8px;
    display: flex;
    align-items: center;
  }
  .count-down {
    position: relative;
    .day {
      position: absolute;
      left: 1rem;
      top: 2.5rem;
      width: 1.5rem;
      font-size: 1.3rem;
      text-align: center;
      color: #163d96;
      font-family: "AlibabaPuHuiTi-3-85-Bold";
    }
    .hours {
      position: absolute;
      left: 3.1rem;
      top: 2.5rem;
      width: 1.5rem;
      color: #163d96;
      text-align: center;
      font-size: 1.3rem;
      font-family: "AlibabaPuHuiTi-3-85-Bold";
    }
  }
  .img-box {
    box-sizing: border-box;
    padding-left: 8px;
    padding-right: 8px;
    flex: 1;
    // height: 4rem;
    img {
      margin-top: 16px;
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>
